import { ActionHistoryStore, CustomersStore, CustomersTableStore, ImagesStore } from 'mobx-stores'
import { DepartmentsStore, DepartmentsTableStore } from 'mobx-stores/departments'
import { GeneralStore } from 'mobx-stores/general-store'
import { LegalTableStore } from 'mobx-stores/legal/legal-table/legal-table-store'
import { NotificationsStore } from 'mobx-stores/notifications'
import {
  ProductsTableStore, StoreProductsTableStore
} from 'mobx-stores/products'
import { routingStore } from 'mobx-stores/routing-store'
import { StatisticsStore, StatisticsTableStore } from 'mobx-stores/statistics'
import {
  AddStorePageStore, StoreSearchStore, StoresMainStore,
  StoresTableStore,
  ViewStorePageStore,
} from 'mobx-stores/stores'
import { OrdersTableStore, OrdersDetailsStore } from 'mobx-stores/orders'
import {
  AddUserPageStore, UserProfilePageStore, UserSearchStore,
  UsersInStoreTableStore, UsersMainStore, UsersTableStore, UserStore
} from 'mobx-stores/users'
import { CustomerHistoryTableStore } from 'mobx-stores/customers/customer-history-table-store/customer-history-table-store'
import { CustomerProfilePageStore } from 'mobx-stores/customers/customer-profile-page-store'
import { AllowedSsoEmailsStore } from '../setting-store/allowed-sso-emails-store'
import { ApiKeysTableStore } from '../setting-store/api-keys-table-store'

export class RootStore {
  routingStore = routingStore
  generalStore = new GeneralStore(this)
  userStore = new UserStore(this)
  addUserPageStore = new AddUserPageStore(this)
  userProfilePageStore = new UserProfilePageStore(this)
  addStorePageStore = new AddStorePageStore(this)
  usersMainStore = new UsersMainStore(this)
  userSearchStore = new UserSearchStore(this)
  storesMainStore = new StoresMainStore(this)
  storesTableStore = new StoresTableStore(this)
  viewStorePageStore = new ViewStorePageStore(this)
  usersInStoreTableStore = new UsersInStoreTableStore()
  storeProductsTableStore = new StoreProductsTableStore(this)
  usersTableStore = new UsersTableStore(this)
  storeSearchStore = new StoreSearchStore(this)
  productsTableStore = new ProductsTableStore(this)
  departmentsStore = new DepartmentsStore(this)
  departmentsTableStore = new DepartmentsTableStore(this)
  legalTableStore = new LegalTableStore(this)
  customersStore = new CustomersStore(this)
  customersTableStore = new CustomersTableStore(this);
  customerHistoryTableStore = new CustomerHistoryTableStore(this);
  customerProfilePageStore = new CustomerProfilePageStore(this);
  statisticsTableStore = new StatisticsTableStore(this)
  statisticsStore = new StatisticsStore(this)
  notificationsStore = new NotificationsStore(this)
  imagesStore = new ImagesStore(this)
  ordersStore = new OrdersTableStore(this)
  ordersDetailsStore = new OrdersDetailsStore(this)
  actionHistoryStore = new ActionHistoryStore(this)
  apiKeysTableStore = new ApiKeysTableStore(this)
  allowedSsoEmailsStore = new AllowedSsoEmailsStore(this)
}

const rootStore = new RootStore();
export default rootStore;
